import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { isString } from 'lodash';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const mutateMeter = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { data } = await apiClient.put(`/meters/${payload.meter_id}`, { display_name: payload.display_name });
    return data;
  }
  const { data } = await apiClient.post('/meters', payload);
  return data;
};

export const useMutateMeterHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutateMeter,
    onSuccess: (_, variables) => {
      dispatch(showSnackbar({ message: 'Meter saved successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['meters'] });
      if (onSuccess) onSuccess(variables);
    },
    onError: (err) => {
      if (err instanceof AxiosError) {
        if (err.response?.status === 400) {
          setError(err.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: err.response?.data?.message || err.message, severity: 'error' }));
        return;
      }
      dispatch(
        showSnackbar({
          message: isString(err?.message) ? err.message : JSON.stringify(err?.message),
          severity: 'error',
        }),
      );
    },
  });

  const onSubmit = async (payload, isEdit) => mutation.mutate({ payload, isEdit });

  return {
    data: mutation.data,
    isError: mutation.isError,
    error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
